import { render, staticRenderFns } from "./MenuModule.vue?vue&type=template&id=4d1a669f&"
import script from "./MenuModule.vue?vue&type=script&lang=js&"
export * from "./MenuModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports